import {
  Directive,
  OnInit,
  Input,
  TemplateRef,
  ViewContainerRef,
} from "@angular/core";
import { TokenService } from "../services/token.service";

@Directive({
  selector: "[appPermsRoles]",
})
export class PermsRolesDirective implements OnInit {
  private userRoles = [];
  private permissiones = [];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private tokenService: TokenService
  ) {
    this.userRoles = this.tokenService.getRoles();
  }

  ngOnInit(): void {
    this.updateView();
  }
  @Input()
  set appPermsRoles(val: Array<String>) {
    this.viewContainer.createEmbeddedView(this.templateRef);
    this.permissiones = val;
    this.updateView();
  }

  private updateView() {
    this.viewContainer.clear();
    if (this.checkPermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
  private checkPermission(): boolean {
    let permissionStatus = false;
    if (this.userRoles && this.permissiones) {
      this.userRoles.forEach((element) => {
        if (this.permissiones.indexOf(element) > -1) {
          permissionStatus = true;
        }
      });
    }
    return permissionStatus;
  }
}
